import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'RestorationCategory' })
export class RestorationCategory {
  @Key id?: number;
  name: string;
  delta: number;
}
